import { render, staticRenderFns } from "./OnboardingRoot.vue?vue&type=template&id=6c97d4f4"
import script from "./OnboardingRoot.vue?vue&type=script&lang=ts"
export * from "./OnboardingRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports